import axiosInstance from "../lib/axiosInstance";

class ecomcategoriesModel {

    constructor() {
        this.base_url = "/ecom_categories"
    }
    async list(query = []) {

        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
    async create(data = []) {
        return await axiosInstance.post(this.base_url, data);
    }
    async update(id, data = []) {
        return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
    }
    async destroy(id, data = []) {
        return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    }
    async show(id, data = []) {
        return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    }
    async generate(id, data = []) {
        return await axiosInstance.post(`${this.base_url}/${id}/generate`, data);
    }
    async postExcel(id, data = []) {
        return await axiosInstance.post(`/product/${id}/import`, data);
    }

}

export default new ecomcategoriesModel();